// extracted by mini-css-extract-plugin
module.exports = {"applist":"AppList_applist__YJ3ka"};